import { defineComponent, defineAsyncComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import App from './App.class';



export default defineComponent({
	props: {
		isOverviewAI: {
			type: Boolean,
			required: false,
		},
		studyId: {
			type: Number,
			default: null,
		}
	},

	components: {
		OverviewAI: defineAsyncComponent(() => import('./overviewAI/OverviewAI.vue')),
		OverviewWrapper: defineAsyncComponent(() => import('./overview/OverviewWrapper/OverviewWrapper.vue')),
	},
	setup: () => { 
		const codeBehind = new App();
		return setupComponent(codeBehind);
	},
});
